import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@finam/web-ui-kit';
import { PrimaryButton } from '@finam/web-ui-kit/Button/Button.styles';
import React from 'react';
import ReactModal from 'react-modal';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import { FileLink } from '../Common/FileLink';
import { SMSCodePanel } from '../Common/SMSCodePanel';
import InnerDocuments from '../InnerDocuments';
import './Steps.scss';
import IFieldInfo from '../Data/IFieldInfo';
import FileField from '../Fields/FileField';
import { getBase64 } from '../../filesHelper';


interface IState {
    isLoading: boolean;
    isBtnLoading: boolean;
    isBtnDisabled: boolean;
    docs: { nnDoc: number, strDocType: string, nnDocType: number, isSigned: boolean }[];
    showCodePanel?: boolean;
    showInnerDocs?: boolean;
    confirmId?: string;
    phones?: string;
    smscode?: string;
    signedDocs: number[];
    field?: IFieldInfo
}

export default class SigningStep extends React.Component<{ endAction: () => void }, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            docs: [],
            isBtnLoading: true,
            isBtnDisabled: true,
            signedDocs: []
        }
    }

    componentDidMount() {
        this.GetDocs();
    }

    private GetDocs() {
        const ws = new WebService(this.context.token);
        this.setState({ isLoading: true, signedDocs: [] });
        ws.GetSigningDocs().then(res => this.setState({ docs: res, isBtnDisabled: false, isBtnLoading: false, isLoading: true, }));
        ws.GetPersonalDocuments(3760).then(res => {
            const fi = res[0];
            if (fi) {
                const field: IFieldInfo = {
                    fieldTitle: fi.fieldName,
                    files: fi.files || [],
                    nnDoc: fi.nnDoc,
                    nnDocType: fi.nnDocType,
                    strDocCode: fi.strDocCode,
                    isRequired: fi.isRequired,
                    description: fi.description
                };
                this.setState({ field });
            }

        });
    }


    private SignDocuments(docIds: number[]) {
        this.setState({ isBtnLoading: true, signedDocs: docIds });
        new WebService(this.context.token).SignUNEPDocuments({ docIds: docIds }).then(res => { this.setState({ isBtnLoading: false, isBtnDisabled: true, showCodePanel: true, phones: res.phones, confirmId: res.confirmId }) });
    }

    private uploadFieldDoc(files: FileList | null): void {
        if (!this.state.field || !files)
            return;
        var newField = { ...this.state.field };
        Array.from(files).forEach(file =>
            newField.files.push({ fileName: file.name, file: file, fileId: 1 }));
        this.setState({ field: newField });
    }


    private async uploadDocs(): Promise<void> {
        const filesToUpload = this.state.field?.files?.filter(f => !!f.file);
        if (!!this.state.field && filesToUpload && filesToUpload.length > 0) {
            var filesData: { file64: string, fileName: string }[] = [];
            var filesPromises = this.state.field.files.map(async (file) => {
                if (file.file) {
                    const data = await getBase64(file.file);
                    filesData.push({ file64: data.data, fileName: file.fileName });
                }
            });
            await Promise.all(filesPromises);
            await new WebService(this.context.token).PostFileInfo({ items: filesData, nnDoc: this.state.field.nnDoc, strDocCode: this.state.field.strDocCode });
        }
    }

    render(): React.ReactNode {
        const firstDocs = this.state.docs.filter(d => d.nnDocType == 1807);
        const secondDocs = this.state.docs.filter(d => d.nnDocType != 1807);
        const firstDocEnableSign = firstDocs.findIndex(d => !d.isSigned) > -1;
        const secondDocEnableSign = !firstDocEnableSign && secondDocs.findIndex(d => !d.isSigned) > -1;
        return <div className='signing-step'>
            <h2 className='step-title'>Электронная трудовая книжка</h2>
            <p className='step-description'>
                Загрузите документ с госуслуг на текущую дату
            </p>
            {this.state.field &&
                <div className='emplHistoryDoc'>
                    <FileField
                        isRequired={this.state.field.isRequired}
                        files={this.state.field.files && this.state.field.files.map(f => ({ name: f.fileName, id: f.fileId, isNew: !!f.file }))}
                        nnDoc={this.state.field.nnDoc}
                        onChange={(v) => { this.uploadFieldDoc(v) }}
                    />
                    <Button size='small' onClick={() => { this.uploadDocs().then(d => this.GetDocs()) }}>Загрузить</Button></div>
            }

            <h2 className='step-title'>Подпишите документы</h2>
            <div style={{ marginBottom: '10px' }}>
                <p className='step-description'>
                    Внимательно ознакомьтесь с <a onClick={() => { this.setState({ showInnerDocs: true }) }}>внутренними документами компании</a> и подпишите лист ознакомления с помощью УНЭП.
                </p>
                <div className='signing-docs'>
                    {firstDocs.map((d, i) => <div key={`sdoc${i}`}>
                        <FileLink docId={d.nnDoc} docTitle={d.strDocType} /></div>)}
                </div>
                <Button
                    disabled={this.state.isBtnLoading || this.state.isBtnDisabled || !firstDocEnableSign}
                    loading={this.state.isBtnLoading}
                    onClick={() => { this.setState({ isBtnLoading: true }); this.SignDocuments(firstDocs.map(d => d.nnDoc)); }}
                >Подписать</Button>
            </div>
            <div>
                <p className='step-description'>
                    Внимательно ознакомьтесь с документами перед подписанием. После этого нажмите кнопку «Подписать с помощью УНЭП».s
                </p>
                <div className='signing-docs'>
                    {secondDocs.map((d, i) => <div key={`sdoc${i}`}>
                        <FileLink docId={d.nnDoc} docTitle={d.strDocType} /></div>)}
                </div>
                <div>
                    <Button
                        disabled={this.state.isBtnLoading || this.state.isBtnDisabled || !secondDocEnableSign}
                        loading={this.state.isBtnLoading}
                        onClick={() => { this.setState({ isBtnLoading: true }); this.SignDocuments(secondDocs.map(d => d.nnDoc)); }}
                    >Подписать</Button></div>
                {this.state.showCodePanel && <SMSCodePanel
                    confirmId={this.state.confirmId || ''}
                    docIds={this.state.docs.map(d => d.nnDoc)}
                    message={`На ваш телефон ${this.state.phones} ушла СМС с кодом. Пожалуйста введите его в поле ниже и нажмите Отправить`}
                    afterAction={() => { this.setState({ showCodePanel: false }); this.GetDocs(); this.props.endAction(); }}
                />}
            </div>
            <Dialog open={!!this.state.showInnerDocs}>
                <DialogTitle>Внутренние документы</DialogTitle>
                <DialogContent><InnerDocuments /></DialogContent>
                <DialogActions>
                    <Button onClick={(e: any) => { e.stopPropagation(); this.setState({ showInnerDocs: false }); }}>
                        Выход
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }
}